<template>
  <span
    class="tw-inline-flex tw-aspect-[1/1] tw-h-[16px] tw-w-[16px] tw-items-center tw-justify-center tw-leading-none xs2:tw-h-[14px] xs2:tw-w-[14px] md:tw-h-[16px] md:tw-w-[16px]"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      class="tw-h-full tw-w-full"
    >
      <path
        d="M13.5 4.5H2V3C2 2.86739 1.94732 2.74021 1.85355 2.64645C1.75979 2.55268 1.63261 2.5 1.5 2.5C1.36739 2.5 1.24021 2.55268 1.14645 2.64645C1.05268 2.74021 1 2.86739 1 3V13C1 13.1326 1.05268 13.2598 1.14645 13.3536C1.24021 13.4473 1.36739 13.5 1.5 13.5C1.63261 13.5 1.75979 13.4473 1.85355 13.3536C1.94732 13.2598 2 13.1326 2 13V11H15V13C15 13.1326 15.0527 13.2598 15.1464 13.3536C15.2402 13.4473 15.3674 13.5 15.5 13.5C15.6326 13.5 15.7598 13.4473 15.8536 13.3536C15.9473 13.2598 16 13.1326 16 13V7C16 6.33696 15.7366 5.70107 15.2678 5.23223C14.7989 4.76339 14.163 4.5 13.5 4.5ZM2 5.5H6.5V10H2V5.5Z"
        fill="#AC5209"
      />
    </svg>
  </span>
</template>
<script>
export default {
  name: 'BedRoom',
};
</script>
